export const getWalletInfo = "/auth/partner/wallet/balance";
export const getBankList = "/auth/list/bank?page=1&limit=1000000&size=1000000";
export const verifyBankDetails = "/auth/verify/bank";
export const updateBankDetails = "/auth/bank/partner";
export const walletCounter = "/reports/transactions/partner/wallet/inflow";
export const checkoutPath = "/checkout/initialize";
